module.exports = __webpack_public_path__ + "static/media/quote-plato-discourage.ffe28b08.png";